// import axios from 'axios';
import Cookies from 'js-cookie/src/js.cookie';

/**
 * PDP Popup Modal that appears on first visit
 */
const initUpsellsPopup = (): void => {
  const body = document.querySelector('body');
  const upsellsPopupTrigger = document.querySelector('[data-upsells-popup-trigger]') as HTMLButtonElement;
  const modalUnderlay = document.querySelector('.modal-underlay') as HTMLElement;
  const atcBtn = document.querySelector('[data-atc-btn]');
  const atcBtnUpsell = document.querySelector('[data-add-to-cart-upsell]');
  const modalCloseBtn = document.querySelector('.cart-upsells-modal__close');

  if (!upsellsPopupTrigger) return;

  if (atcBtnUpsell) {
    atcBtnUpsell.addEventListener('click', () => {
      console.log('upsell added to cart')
      window.setTimeout(()=> {
        location.reload()
      },3000)
    })
  }
  
  upsellsPopupTrigger.addEventListener('click', (event) => {
    if (!Cookies.get('seen_upsells_modal')) {
      event.preventDefault();
      console.log('open upsell modal, set cookie');
      body.setAttribute('data-modal-triggered', 'modal-upsells');
      atcBtn.removeAttribute('data-click-toggle');
      atcBtn.removeAttribute('data-upsells-popup-trigger');
      Cookies.set('seen_upsells_modal', true);
    } else {
      console.log('seen upsell modal');
      body.removeAttribute('data-modal-triggered');
      body.classList.remove('cart-upsells-open');
      modalUnderlay.style.display = 'none';
      atcBtn.setAttribute('type', 'submit');
    }
  });

  modalCloseBtn.addEventListener('click', () => {
    body.removeAttribute('data-modal-triggered');
    modalUnderlay.style.display = 'none';
  })

  // reset states
  if (Cookies.get('seen_upsells_modal')) {
    console.log('reset states')
    atcBtn.setAttribute('type', 'submit');
    body.removeAttribute('data-modal-triggered');
    body.classList.remove('cart-upsells-open');
    modalUnderlay.style.display = 'none';
  } 
}

export { initUpsellsPopup };